import React from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import { HomeDeliveryBadge } from './home-delivery-badge';
import { PriceTypeNoticeBadge } from './price-type-badge';
import { CountryBadge } from './country-badge';
import { StockBadge } from './stock-badge';
import { DeliveryTime } from '../delivery-time';
import { AlternativePrice } from 'src/types';
import { getCampaignByOfferId } from '../../../utils';
import {
  Column,
  MediumUpFlex,
  FirstRow,
  MobileOnlyFlex,
  SecondRow,
} from './styles';
import { OfferPriceLabel } from 'src/components/offer/price/offer-price';

import { MobileAndDesktopOnly, TabletOnly } from 'src/ui/block';
import { AuthorizedDealerBadge } from '../authorized-dealer';

interface IStockPriceInfo {
  alternativeOffer?: AlternativePrice;
}

export const StockPriceInfo: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IStockPriceInfo>
>> = props => {
  const { alternativeOffer } = props;
  const { campaign, isFeatured, offer, priceDisplay } = usePriceRowContext();
  const { isInternationalPrice, deliveryOptions, store } = offer;

  // Get props from alternative offer if supplied
  const id = alternativeOffer ? alternativeOffer.id : offer.priceId;
  const price = alternativeOffer ? alternativeOffer.price : offer.price;
  const offerPrices = alternativeOffer
    ? alternativeOffer.offerPrices
    : offer.offerPrices;
  const shipping = alternativeOffer
    ? alternativeOffer.shipping
    : offer.shipping;
  const stock = alternativeOffer ? alternativeOffer.stock : offer.stock;
  const priceType = alternativeOffer
    ? null // Not applicable for alternative offers
    : offer.priceType;
  const homeDelivery = alternativeOffer
    ? null // Not applicable for alternative offers
    : deliveryOptions &&
      deliveryOptions.find(option => option && option.type === 'HOME_DELIVERY');

  const activeCampaign = getCampaignByOfferId(id, campaign);

  const isDownload = offer.priceType === 'download';

  return (
    <Column>
      <FirstRow>
        {price && (
          <OfferPriceLabel
            price={price}
            offerPrice={offerPrices}
            priceDisplay={priceDisplay}
            campaignColors={activeCampaign?.media?.colors}
          />
        )}
      </FirstRow>
      {isFeatured && (
        <>
          <SecondRow>
            {!alternativeOffer && offer.authorizedDealer && (
              <MobileAndDesktopOnly>
                <AuthorizedDealerBadge />
              </MobileAndDesktopOnly>
            )}
            <MediumUpFlex>
              {priceType && <PriceTypeNoticeBadge priceType={priceType} />}
              {store?.countryCode && isInternationalPrice && (
                <CountryBadge countryCode={store?.countryCode} />
              )}
              {!isDownload && (
                <StockBadge
                  status={stock?.status}
                  statusText={stock?.statusText}
                />
              )}
            </MediumUpFlex>

            {!isDownload && homeDelivery && <HomeDeliveryBadge />}

            {!isDownload && (
              <MobileOnlyFlex>
                <StockBadge
                  status={stock?.status}
                  statusText={stock?.statusText}
                />
              </MobileOnlyFlex>
            )}
            {!isDownload && (
              <DeliveryTime shipping={shipping} stockStatus={stock?.status} />
            )}
          </SecondRow>

          {!alternativeOffer && offer.authorizedDealer && (
            <TabletOnly>
              <SecondRow>
                <AuthorizedDealerBadge />
              </SecondRow>
            </TabletOnly>
          )}
        </>
      )}
    </Column>
  );
};
